export default __webpack_public_path__ + "static/media/1807.7fcbae36.png";